export default __webpack_public_path__ + "media/img_02/600@2x-6f2b0aed.png";